import { mobile } from '@bilibili-maoer/web-utils'

import { TooltipPropsType } from '~/core/components/tooltip/common'
import { DesktopTooltip } from '~/core/components/tooltip/desktop-tooltip'
import { MobileTooltip } from '~/core/components/tooltip/mobile-tooltip'

export const Tooltip = (props: TooltipPropsType) =>
  mobile.isMobile() ? <MobileTooltip {...props} /> : <DesktopTooltip {...props} />
